
import React, { useContext, useState } from "react";
//import { NavLink, useLocation } from "react-router-dom";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";

const MENU = [
  { type: "group", label: "Enquiry Management" },
  {
    label: "Enquiries",
    route: "/elosca-crm/enquiry",
    icon: "fas fa-list-alt",
  },
  {
    label: "Create Enquiry",
    route: "/elosca-crm/enquiry/create",
    icon: "fas fa-plus-circle",
  },
  {
    label: "Assignment Queue",
    route: "/elosca-crm/enquiry/assignment-queue",
    icon: "fas fa-user-check",
  },
  {
    label: "Qualification Workbench",
    route: "/elosca-crm/enquiry/qualification",
    icon: "fas fa-clipboard-check",
  },
  {
    label: "Conversion Queue",
    route: "/elosca-crm/enquiry/conversion-queue",
    icon: "fas fa-exchange-alt",
  },
  {
    label: "Lost Enquiries",
    route: "/elosca-crm/enquiry/lost",
    icon: "fas fa-folder-minus",
  },
  {
    label: "Duplicate Review",
    route: "/elosca-crm/enquiry/duplicate-review",
    icon: "fas fa-copy",
  },
  {
    label: "Import Enquiries",
    route: "/elosca-crm/enquiry/import",
    icon: "fas fa-file-import",
  },
  {
    label: "Enquiry Reports",
    route: "/elosca-crm/enquiry/reports",
    icon: "fas fa-chart-bar",
  },
];

export default function EloscaCRMSidebar({ onToggle }) {
  const { permissions } = useContext(AuthContext);
  const location = useLocation();

  const [expanded, setExpanded] = useState(true);

  const toggleSidebar = () => {
    setExpanded((current) => {
      const next = !current;
      onToggle?.(next);
      return next;
    });
  };

  const hasPermission = (item) => {
    // Do not hide the initial screen while the ELOSCA permission
    // master is being established. Add approved permission keys here.
    if (!item.permission) return true;

    return permissions?.[item.permission]?.view === true;
  };

  return (
    <aside
      className={`elosca-sidebar ${expanded ? "expanded" : "collapsed"}`}
    >
      <div className="elosca-sidebar-header">
        {expanded && <strong>Enquiry Management</strong>}

        <button
          type="button"
          onClick={toggleSidebar}
          aria-label={expanded ? "Collapse sidebar" : "Expand sidebar"}
          title={expanded ? "Collapse sidebar" : "Expand sidebar"}
        >
          <i className="fas fa-bars" />
        </button>
      </div>
      <Link
            to="/dashboard"
            className="elosca-back-dashboard"
            title={!expanded ? "Back to Dashboard" : undefined}
            >
            <i className="fas fa-home" />
            {expanded && <span>Back to Dashboard</span>}
            </Link>  
      <nav className="elosca-sidebar-nav" aria-label="Enquiry Management">
        {MENU.filter((item) => item.type === "group" || hasPermission(item)).map((item, index) => {
            if (item.type === "group") {
                return expanded ? (
                <div key={`group-${index}`} className="elosca-sidebar-group">
                    {item.label}
                </div>
                ) : null;
            }
          const active =
            location.pathname === item.route ||
            (item.route !== "/elosca-crm/enquiry" &&
              location.pathname.startsWith(`${item.route}/`));

          return (
            <NavLink
              key={item.route}
              to={item.route}
              end={item.route === "/elosca-crm/enquiry"}
              className={`elosca-sidebar-link ${active ? "active" : ""}`}
              title={!expanded ? item.label : undefined}
            >
              <i className={item.icon} aria-hidden="true" />

              {expanded && <span>{item.label}</span>}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
